import { Box, Flex } from "@chakra-ui/react";

import { Button } from "components";

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  onSkip: () => void | null;
}

export const ProgressIndicator = ({
  currentStep,
  totalSteps,
  onSkip,
}: ProgressIndicatorProps) => (
  <Flex align="center" justify="space-between" height={8}>
    <Box flex="1" mr={2} h="4px" position="relative">
      {/* Unfilled track */}
      <Box
        position="absolute"
        inset={0}
        bg="var(--color-primary-btn-bg)"
        opacity={0.2}
        borderRadius="full"
      />
      {/* Filled track */}
      <Box
        position="absolute"
        left={0}
        top={0}
        bottom={0}
        bg="var(--color-primary-btn-bg)"
        width={`${(currentStep / totalSteps) * 100}%`}
        borderRadius="full"
        transition="width 0.3s ease"
      />
    </Box>
    {onSkip && (
      <Button variant="text" onClick={onSkip}>
        Skip
      </Button>
    )}
  </Flex>
);
